/* Kopfleiste  ·  Created By Ill
   Gehoert zu sections/cbi-header.liquid.

   HERKUNFT
   Der Code stammt aus assets/cliffhanger.js, wo er zwischen dem
   Produktseiten-Code steckt. Dort ist er nicht wiederverwendbar: die Datei
   steigt in Zeile 9 aus, wenn das Produktgeruest fehlt, und ihr
   Scroll-Handler haengt am Scroll-Container der Produktseite statt am
   Fenster. Beides ist hier aufgeloest - sonst ist es dieselbe Mechanik.

   WAS DRIN IST
   1 Menueschublade mit aufklappbaren Unterpunkten
   2 Suchfeld, das unter der Leiste aufklappt
   3 Dropdowns fuer Land und Sprache, das Laender-Dropdown mit Suchfeld
   4 Leiste beim Scrollen ausblenden, beim Hochwischen zurueckholen
   5 Zaehler am Warenkorbsymbol nachziehen

   Die drei Ueberlagerungen - Schublade, Suche, Dropdown - schliessen sich
   gegenseitig. Deshalb stehen sie zusammen in einer Datei und rufen sich
   direkt auf.

   Laeuft nur auf normalen Seiten. Die Produktseite bringt ihre eigene
   Kopfleiste und ihr eigenes Script mit, die beiden treffen sich nie. */

(function () {
  if (window.__cbiHeaderBound) return;
  window.__cbiHeaderBound = true;

  var root = document.getElementById('CbiHeaderRoot');
  if (!root) return;

  var host = root.closest('.shopify-section') || root.parentElement;

  function isWide() {
    return window.matchMedia('(min-width:1000px)').matches;
  }

  function viewH() {
    return (window.visualViewport && window.visualViewport.height) || window.innerHeight;
  }

  /* ----
     1  Menueschublade
  ---- */
  var burger = document.getElementById('cbiBurger');
  var drawer = document.getElementById('cbiDrawer');

  function drListsClose() {
    if (!drawer) return;
    [].slice.call(drawer.querySelectorAll('li.has-dd.is-open')).forEach(function (li) {
      li.classList.remove('is-open');
      var d = li.querySelector('.dd');
      if (d) d.hidden = true;
      var t = li.querySelector('.dd-t');
      if (t) t.setAttribute('aria-expanded', 'false');
    });
  }

  function drKey(e) {
    if (e.key === 'Escape' || e.keyCode === 27) drClose();
  }

  function drOpen() {
    if (!drawer) return;
    seClose();
    /* Die Leiste muss sichtbar sein, sonst haengt die Schublade unter
       einer weggefahrenen Kopfleiste. */
    navHide(false);

    /* Unterkante der Leiste im Fenster messen: ganz oben liegt die
       Ankuendigungsleiste noch darueber, weiter unten klebt die Kopfleiste
       am Rand. offsetHeight statt der Rechteckhoehe, damit die laufende
       Einblend-Bewegung die Zahl nicht verfaelscht. */
    var edge = (host || root).getBoundingClientRect().top;
    if (edge < 0) edge = 0;
    edge = edge + ((host || root).offsetHeight || 0);
    drawer.style.setProperty('--drawer-top', Math.round(edge) + 'px');

    drawer.hidden = false;
    requestAnimationFrame(function () {
      drawer.classList.add('is-open');
    });
    if (burger) {
      burger.setAttribute('aria-expanded', 'true');
      burger.classList.add('is-x');
    }
    document.body.classList.add('cbi-hd-locked');
    document.addEventListener('keydown', drKey);
  }

  function drClose() {
    if (!drawer || drawer.hidden) return;
    drawer.classList.remove('is-open');
    if (burger) {
      burger.setAttribute('aria-expanded', 'false');
      burger.classList.remove('is-x');
    }
    document.body.classList.remove('cbi-hd-locked');
    setTimeout(function () {
      drawer.hidden = true;
      drListsClose();
    }, 280);
    document.removeEventListener('keydown', drKey);
  }

  if (burger) {
    burger.addEventListener('click', function (e) {
      e.preventDefault();
      if (drawer && drawer.hidden) drOpen();
      else drClose();
    });
  }

  if (drawer) {
    drawer.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      var t = e.target.closest('.dd-t');
      if (!t) return;
      var li = t.parentElement;
      var wasOpen = li.classList.contains('is-open');
      drListsClose();
      if (!wasOpen) {
        li.classList.add('is-open');
        var d = li.querySelector('.dd');
        if (d) d.hidden = false;
        t.setAttribute('aria-expanded', 'true');
      }
    });
  }

  /* ----
     2  Suche
  ---- */
  var seBtn = document.getElementById('cbiSearchBtn');
  var seBox = document.getElementById('cbiSearch');
  var seInp = document.getElementById('cbiSearchInput');

  function seClose() {
    if (!seBox || seBox.hidden) return;
    seBox.hidden = true;
    if (seBtn) seBtn.setAttribute('aria-expanded', 'false');
  }

  function seOpen() {
    if (!seBox) return;
    ddCloseAll(null);
    seBox.hidden = false;
    if (seBtn) seBtn.setAttribute('aria-expanded', 'true');
    if (seInp) {
      setTimeout(function () {
        try {
          seInp.focus();
          seInp.select();
        } catch (e) {}
      }, 30);
    }
  }

  /* ----
     3  Dropdowns fuer Land und Sprache

     Gefiltert wird ueber den sichtbaren Text der Zeile, also Landesname,
     Waehrungskuerzel und Symbol - "eur" findet damit alle Euro-Laender.
  ---- */
  function ddFilter(dd, q) {
    q = (q || '').trim().toLowerCase();
    var hit = 0;
    [].slice.call(dd.querySelectorAll('li')).forEach(function (li) {
      var ok = q === '' || (li.textContent || '').toLowerCase().indexOf(q) > -1;
      li.hidden = !ok;
      if (ok) hit++;
    });
    var non = dd.querySelector('.non');
    if (non) non.hidden = hit > 0;
  }

  function ddCloseAll(except) {
    [].slice.call(root.querySelectorAll('.chx-sel.is-open')).forEach(function (s) {
      if (s === except) return;
      s.classList.remove('is-open');
      var d = s.querySelector('.chx-dd');
      if (d) {
        d.hidden = true;
        d.classList.remove('is-up');
      }
      var b = s.querySelector('.chx-selbtn');
      if (b) b.setAttribute('aria-expanded', 'false');
    });
  }

  function ddToggle(btn) {
    var sel = btn.closest('.chx-sel');
    var dd = sel.querySelector('.chx-dd');
    var wasOpen = sel.classList.contains('is-open');
    ddCloseAll(null);
    seClose();
    if (wasOpen || !dd) return;
    dd.hidden = false;
    dd.classList.remove('is-up');
    sel.classList.add('is-open');
    btn.setAttribute('aria-expanded', 'true');

    var r = dd.getBoundingClientRect();
    if (r.bottom > viewH() - 8) dd.classList.add('is-up');

    var f = dd.querySelector('.chx-ddfind');
    if (f) {
      f.value = '';
      ddFilter(dd, '');
      /* Am Handy nicht selbst hineinspringen - sonst faehrt beim Oeffnen
         sofort die Tastatur hoch. */
      if (isWide()) {
        setTimeout(function () {
          try {
            f.focus();
          } catch (e) {}
        }, 30);
      }
    }

    var cur = dd.querySelector('.is-cur');
    if (cur && cur.scrollIntoView) cur.scrollIntoView({ block: 'nearest' });
  }

  document.addEventListener('input', function (e) {
    var f = e.target.closest ? e.target.closest('.chx-ddfind') : null;
    if (!f || !root.contains(f)) return;
    var dd = f.closest('.chx-dd');
    if (dd) ddFilter(dd, f.value);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.keyCode !== 13) return;
    var f = e.target.closest ? e.target.closest('.chx-ddfind') : null;
    if (!f || !root.contains(f)) return;
    e.preventDefault();
    var dd = f.closest('.chx-dd');
    var b = dd ? dd.querySelector('li:not([hidden]) [data-code]') : null;
    if (b) b.click();
  });

  /* ----
     4  Leiste beim Scrollen

     Runterwischen blendet sie aus, Hochwischen holt sie zurueck, ganz
     oben steht sie immer. Auf der Produktseite haengt dieselbe Logik am
     eigenen Scroll-Container - hier am Fenster.
  ---- */
  var lastY = window.pageYOffset || 0;

  function navHide(on) {
    if (!host) return;
    if (on === host.classList.contains('is-hidden')) return;
    host.classList.toggle('is-hidden', on);
    if (on) {
      seClose();
      ddCloseAll(null);
    }
  }

  window.addEventListener(
    'scroll',
    function () {
      /* Bei offener Schublade nichts bewegen. */
      if (drawer && !drawer.hidden) return;

      var y = window.pageYOffset || document.documentElement.scrollTop || 0;
      var d = y - lastY;

      if (y <= 6) {
        navHide(false);
        if (host) host.classList.remove('is-shadow');
      } else {
        if (host) host.classList.add('is-shadow');
        if (d > 4) navHide(true);
        if (d < -4) navHide(false);
      }

      lastY = y;
    },
    { passive: true }
  );

  /* ----
     5  Ein Klickfaenger fuer alles
  ---- */
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;

    if (e.target.closest('#cbiSearchBtn')) {
      e.preventDefault();
      if (seBox && seBox.hidden) seOpen();
      else seClose();
      return;
    }

    var sb = e.target.closest('.chx-selbtn');
    if (sb && root.contains(sb)) {
      e.preventDefault();
      ddToggle(sb);
      return;
    }

    var cd = e.target.closest('[data-code]');
    if (cd && cd.closest('.chx-dd') && root.contains(cd)) {
      e.preventDefault();
      var inp = document.getElementById('cbiCtryCode');
      var frm = document.getElementById('cbiCtryForm');
      if (inp && frm) {
        inp.value = cd.getAttribute('data-code');
        frm.submit();
      }
      return;
    }

    if (!e.target.closest('.chx-search')) seClose();
    if (!e.target.closest('.chx-dd')) ddCloseAll(null);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' || e.keyCode === 27) {
      ddCloseAll(null);
      seClose();
    }
  });

  /* ----
     6  Zaehler am Warenkorbsymbol

     Dawn zieht dafuer sonst den Abschnitt cart-icon-bubble nach. Den gibt
     es hier nur als unsichtbaren Platzhalter, damit cart.js nicht in sein
     catch faellt und faelschlich eine Fehlermeldung zeigt. Der eigene
     Zaehler wird stattdessen ueber das cartUpdate-Ereignis nachgefragt.
  ---- */
  function refreshCount() {
    var url = (window.routes && window.routes.cart_url) || '/cart';
    fetch(url + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        var dot = root.querySelector('.chx-dot');
        if (dot) dot.textContent = cart.item_count;
      })
      .catch(function () {});
  }

  document.addEventListener('DOMContentLoaded', function () {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, refreshCount);
    }
  });

  /* Das Warenkorbsymbol oeffnet die Schublade, statt auf die
     Warenkorbseite zu fuehren. Ohne Javascript bleibt der Link, was er
     ist. Abgefangen in der Capture-Phase, damit der eigene Klickfaenger
     oben danach noch seine Menues schliessen kann. */
  document.addEventListener(
    'click',
    function (e) {
      var cd = document.querySelector('cart-drawer');
      if (!cd || typeof cd.open !== 'function') return;
      if (!e.target || !e.target.closest) return;
      var link = e.target.closest('a[href]');
      if (!link || !root.contains(link)) return;
      if (link.target === '_blank') return;

      var cartPath = (window.routes && window.routes.cart_url) || '/cart';
      var url;
      try {
        url = new URL(link.href, window.location.origin);
      } catch (err) {
        return;
      }
      if (url.origin !== window.location.origin) return;

      function trim(p) {
        return p.length > 1 ? p.replace(/\/+$/, '') : p;
      }
      if (trim(url.pathname) !== trim(cartPath)) return;

      e.preventDefault();
      drClose();
      cd.open(link);
    },
    true
  );
})();
